<template>
  <div>
    <div class="input-wrapper">
      <font-awesome-icon
        class="increment"
        :icon="['fas', 'minus-circle']"
        @click="
          e => {
            e.preventDefault();
            counterVal !== 0 ? counterVal-- : null;
          }
        "
      />
      <input v-model="counterVal" v-on:keypress="isNumber" />
      <font-awesome-icon
        class="increment"
        :icon="['fas', 'plus-circle']"
        @click="
          e => {
            e.preventDefault();
            counterVal++;
          }
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CountInput",
  props: {
    counter: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      counterVal: this.counter,
      minusIntervalId: null,
      plusIntervalId: null
    };
  },
  watch: {
    counterVal: function(newVal) {
      if (newVal === "") {
        this.counterVal = 0;
      } else {
        this.counterVal = parseInt(this.counterVal);
      }
      this.$emit("update:counter", this.counterVal);
    }
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mouseDownMinus: function() {
      this.counterVal--;
    },
    mouseDownMinusStop: function() {
      clearInterval(this.minusIntervalId);
    },
    mouseDownPlus: function() {
      this.counterVal++;
    },
    mouseDownPlusStop: function() {
      clearInterval(this.plusIntervalId);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.input-wrapper {
  display: flex;
  align-items: center;
}

input {
  font-family: $font-primary;
  max-width: 60px;
  font-size: 14px;
}
.increment {
  color: $color-primary;
  padding: 4px;
  font-size: 30px;
  cursor: pointer;
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */

  /* Rules below not implemented in browsers yet */
  -o-user-select: none;
  user-select: none;
}
</style>
